

import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { apiRequest } from './fetchSetup';


// 1️⃣ Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAAlufXQTTk3HZm_lypcypp5CVNj1Mp2J0",
  authDomain: "ayuja-d237b.firebaseapp.com",
  projectId: "ayuja-d237b",
  storageBucket: "ayuja-d237b.firebasestorage.app",
  messagingSenderId: "531525746381",
  appId: "1:531525746381:web:91bf4435053e08fd2ab384",
};

const app = initializeApp(firebaseConfig);

// 2️⃣ Register Service Worker & Get FCM Token
export const registerWebToken = async () => {
  console.log("entered to register web token")
  try {

    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        console.log("User allowed notifications");
      } else {
        console.log("Notifications not allowed");
      }
    } else {
      console.log("This browser does not support notifications");
    }
    

    // Register Service Worker
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      console.log("Service Worker registered:", registration);

      // Get FCM token
      const messaging = getMessaging(app);
      const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

      const token = await getToken(messaging, { vapidKey });
      console.log("Device Token:", token);

      if (token) {
        console.log("Web FCM Token:", token);
        // Send token to backend
        // await fetch(
        //   "https://ec5d2cf25396.ngrok-free.app/api/flask/notify/register_token",
        //   {
            await apiRequest(`${process.env.REACT_APP_FCM_REGISTER_TOKEN}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token }),
          }
        );
      } else {
        console.log("No registration token available");
      }
    } else {
      console.error("Service Workers are not supported in this browser.");
    }
  } catch (err) {
    console.error("Web FCM error:", err);
  }
};
